import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377ec52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Bestellt", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Reserviert", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Auf Lager", -1))

import ArticleStock from '@/model/ArticleStock';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleStockItem',
  props: {
  articleStock: {
    type: ArticleStock,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;

__expose({
  articleStock: props.articleStock,
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (__props.articleStock)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_list, { class: "bg-grey-lighten-5 pa-0 overflow-hidden rounded elevation-1 mb-2 mt-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, { "append-icon": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_subtitle, { class: "spread" }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3,
                    _hoisted_4
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_v_list_item_title, { class: "spread mt-1 pa-3 pt-1" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_chip, {
                        label: "",
                        variant: "outlined",
                        class: "bestand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.articleStock.MengeBestellt), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_chip, {
                        label: "",
                        variant: "outlined",
                        class: "bestand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.articleStock.MengeReserviert), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_chip, {
                        label: "",
                        variant: "outlined",
                        color: __props.articleStock.BestandPhysikalisch > 0 ? 'green' : 'red' ,
                        class: "bestand-text"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("strong", null, _toDisplayString(__props.articleStock.BestandPhysikalisch), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ], undefined, true),
                  _: 1
                })
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})